import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { callAPIInterface, removedAppStatus } from "../../constants";
import MiniAppHeading from "../MiniAppHeading";
import { myAppsLabel } from "../../messages";
import List from "../List";
import { setMyAppsData } from "../../../redux/actions";
import CommonSkeleton from "../../CommonSkeleton";

function MyAppsMainList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const myApps = useSelector((state) => state.common.myApps);

  useEffect(() => {
    handleGetMyApps();
  }, []);

  const handleGetMyApps = async () => {
    try {
      !myApps.length && setIsLoading(true);
      const myAppsResponse = await callAPIInterface(
        "GET",
        `/manage-app/apps-account`
      );

      dispatch(setMyAppsData(myAppsResponse?.data));
    } catch (err) {
      console.log("error while calling app-account", err);
    } finally {
      setIsLoading(false);
    }
  };
  const listSkeleton = () => {
    return (
      <Box className="list-box" sx={{ padding: "12px 15px !important" }}>
        <Box display="flex" gap="10px">
          <CommonSkeleton
            variant="rectangular"
            height="56px"
            width="56px"
            borderRadius="14px"
          />
          <Box>
            <CommonSkeleton variant="text" />
            <CommonSkeleton variant="text" width="200px" />
          </Box>
        </Box>
        <CommonSkeleton
          variant="square"
          height="33px"
          width="70px"
          borderRadius="8px"
        />
      </Box>
    );
  };

  return (
    <Box>
      {isLoading
        ? listSkeleton()
        : !!myApps.length && (
            <>
              <MiniAppHeading
                title={myAppsLabel}
                handleAction={() => navigate("/my-apps/list")}
              />
              <Box padding="12px 15px">
                {myApps?.map((data, idx) => {
                  return (
                    <List
                      key={data.id || idx}
                      data={{ ...data?.app_id }}
                      idx={idx}
                      dataLength={myApps.length}
                      isFrom="myApps"
                      isMainListPage={true}
                      isDisabled={removedAppStatus.includes(
                        data?.app_id?.status
                      )}
                    />
                  );
                })}
              </Box>
            </>
          )}
    </Box>
  );
}

export default MyAppsMainList;
